import { render, staticRenderFns } from "./addSwiper.vue?vue&type=template&id=0a37b251&"
import script from "./addSwiper.vue?vue&type=script&lang=js&"
export * from "./addSwiper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports